<div carousel-item="">
    {{each bannerList item}}
        <!--<div style='background:url('{{item.Img}}') no-repeat;background-size: contain;background-position: center'></div>-->
        <a href="{{item.AndroidUrl}}" target="_blank" style="position:relative;text-align: center;">
            <img src="{{item.Img}}" style="object-fit: contain;">
        </a>
    {{/each}}

</div>